import React from 'react';

export type AcuityOpenDialogProps = {
  ownerId: string;
  calendarId: string;
  appointmentType: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  appointmentName: string;
  isFeedbackFlow?: boolean;
};

export type AcuityContextProviderProps = {
  setShowAcuityDialog: () => void;
  setHideAcutiyDialog: () => void;
  showAcuityDialog: boolean;
};

const AcuityContext = React.createContext<AcuityContextProviderProps | undefined>(undefined);

export const AcuityContextProvider = AcuityContext.Provider;

export const useAcuityContext = () => {
  const context = React.useContext(AcuityContext);
  if (!context) {
    throw new Error('useAcuityContext must be used within a AcuityContextProvider');
  }
  return context;
};
